import React from "react";
import { Link } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import KeyboardArrowRightSharpIcon from "@mui/icons-material/KeyboardArrowRightSharp";
import { setSelectedSubcategory } from "../../store/slices/subCategorySlice";
import {
  selectBreadcrumbs,
  setBreadcrumb,
} from "../../store/slices/breadCrumbsSlice";
import { selectAllCategoryProducts } from "../../features/listingPage/listingPageSlice";

function MobileBreadcrum({ setBreadcrumb, breadcrumbs }) {
  const dispatch = useDispatch();
  const products = useSelector(selectAllCategoryProducts);
  const { vertical, category, subCategory, productName } = breadcrumbs;

  const formattedSubcategory = subCategory?.toUpperCase();

  const handleSubCategorySelected = () => {
    dispatch(
      setSelectedSubcategory(
        breadcrumbs?.subCategoryID && breadcrumbs.subCategoryID
      )
    );
  };

  const handleCategorySelected = () => {
    dispatch(
      setBreadcrumb({
        categoryID: breadcrumbs?.categoryID,
        categoryName: breadcrumbs?.category,
        subCategoryID: 0,
        subCategoryName: "",
        ProductID: 0,
        productName: "",
      })
    );
    dispatch(setSelectedSubcategory(null));
  };

  return (
    <div className="w-full overflow-x-auto whitespace-nowrap bg-white-1 border-b border-gray-100">
      <nav className="flex items-center px-4 py-2 text-gray-800 text-sm font-medium space-x-1">
        {/* Home */}
        <Link to="/" className="text-gray-900 font-semibold">
          Home
        </Link>
        <KeyboardArrowRightSharpIcon className="text-gray-500 text-lg" />

        {/* Vertical */}
        {vertical && (
          <>
            <Link to="/" className="text-gray-800 font-semibold capitalize">
              {vertical}
            </Link>
            <KeyboardArrowRightSharpIcon className="text-gray-500 text-lg" />
          </>
        )}

        {/* Category */}
        {category && (
          <>
            <Link
              to={`/listing-page/${breadcrumbs.categoryID}/${breadcrumbs.category}`}
              onClick={handleCategorySelected}
              className="text-gray-800 font-semibold capitalize"
            >
              {category}
            </Link>
            <KeyboardArrowRightSharpIcon className="text-gray-500 text-lg" />
          </>
        )}

        {/* Subcategory */}
        {subCategory && (
          <>
            <Link
              to={`/listing-page/${breadcrumbs.categoryID}/${breadcrumbs.category}`}
              onClick={handleSubCategorySelected}
              className="text-gray-800 font-semibold capitalize"
            >
              {formattedSubcategory}
            </Link>
            <KeyboardArrowRightSharpIcon className="text-gray-500 text-lg" />
          </>
        )}

        {/* Product Count */}
        {!productName &&
          products?.Data?.product && (
            <span className="text-gray-600 text-sm font-medium ml-1">
              {products.Data.product.length} products found
            </span>
          )}

        {/* Product Name */}
        {productName && (
          <Link
            to=""
            className="truncate text-blue font-semibold border-b border-blue pb-[1px] ml-1 capitalize text-sm"
          >
            {productName}
          </Link>
        )}
      </nav>
    </div>
  );
}

const mapStateToProps = (state) => ({
  breadcrumbs: selectBreadcrumbs(state),
});

const mapDispatchToProps = {
  setBreadcrumb,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileBreadcrum);
